export default __webpack_public_path__ + "media/images/fields-9d4c686b09ca3d6abf893e7a6152c578.jpg";